import { getActionType } from 'modules/CollegeCosts/store/utils';

const STATUS_ORDER = {
  awaiting_result: 1,
  offered: 2,
  accepted: 3,
  not_awarded: 4,
};

function sortScholarships(scholarships) {
  return scholarships.sort(
    (a, b) => STATUS_ORDER[a.status] - STATUS_ORDER[b.status],
  );
}

const initialState = {
  ctx: null,
  roles: [],
  collegeList: [],
  financialInfo: {},
  scholarships: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case getActionType('populateCtx'):
      return {
        ...state,
        ctx: action.ctx,
      };

    case getActionType('populateCollegeList'):
      return {
        ...state,
        collegeList: action.collegeList,
      };

    case getActionType('populateFinancialInfo'):
      return {
        ...state,
        financialInfo: action.financialInfo,
      };

    case getActionType('populateAppliedScholarships'):
      return {
        ...state,
        scholarships: sortScholarships(action.scholarships),
      };

    case getActionType('createScholarship'):
      return {
        ...state,
        scholarships: [...state.scholarships, action.scholarship],
      };

    case getActionType('updateScholarship'):
      return {
        ...state,
        scholarships: state.scholarships.map(s =>
          s.uuid !== action.scholarship.uuid ? s : action.scholarship,
        ),
      };

    case getActionType('sortCollegeList'):
      return {
        ...state,
        collegeList: [...state.collegeList].sort(
          ({ financialPackage: pkgA }, { financialPackage: pkgB }) =>
            pkgA[action.timeframe].familyContribution -
            pkgB[action.timeframe].familyContribution,
        ),
      };
    default:
      return state;
  }
};
